import { render, staticRenderFns } from "./wxLoginComponent.vue?vue&type=template&id=5346aad8"
import script from "./wxLoginComponent.vue?vue&type=script&lang=js"
export * from "./wxLoginComponent.vue?vue&type=script&lang=js"
import style0 from "./wxLoginComponent.vue?vue&type=style&index=0&id=5346aad8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports